import { render, staticRenderFns } from "./RequisitionDetailFormLineCard.vue?vue&type=template&id=0fa0a867&"
import script from "./RequisitionDetailFormLineCard.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetailFormLineCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports